if (!customElements.get('bf-countdown')) {
  customElements.define('bf-countdown', class extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      this.fields = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-${unit}]`));
      if (!Number.isFinite(this.end)) {
        this.hidden = true;
        return;
      }
      this.tick();
      if (this.end > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const remaining = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
      const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
      this.fields.forEach((field, index) => { field.textContent = String(values[index]).padStart(2, '0'); });
      if (remaining === 0) clearInterval(this.interval);
    }
  });
}
